export class ProductQuantity {

    constructor(public availabilityMessage: string,
                public quantityLow: boolean) {}
}
